var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"canvas",class:{'banner_canvas':_vm.showCanvas}},[_c('Header'),_c('Banner')],1)}
var staticRenderFns = []

export { render, staticRenderFns }